import { Button } from "@design";
import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import { Text } from "@/components/Text";

/** A titled section of the space page, with an optional hint and "All …" link. */
export function SpaceSection({
  title,
  hint,
  action,
  children,
}: Readonly<{ title: string; hint?: string; action?: { label: string; onClick: () => void }; children: ReactNode }>) {
  return (
    <section aria-label={title} className="flex flex-col gap-2">
      <div className="flex min-h-8 flex-wrap items-center justify-between gap-x-2">
        <div className="flex flex-wrap items-baseline gap-x-2">
          <Text as="h2" variant="eyebrow" tone="tertiary">
            {title}
          </Text>
          {hint && (
            <Text variant="caption" tone="tertiary">
              {hint}
            </Text>
          )}
        </div>
        {action && (
          <div className="-mr-3">
            <Button variant="text" size="sm" trailingIcon={<ChevronRight size={12} />} onClick={action.onClick}>
              {action.label}
            </Button>
          </div>
        )}
      </div>
      {children}
    </section>
  );
}
